import React, {useCallback} from 'react';
import {VirtualWindow} from "filkersjs-model/dist";
import {useCreation} from "ahooks";
import FromFilkersText from "./icons/FromFilkers.svg";

export interface HeaderProps {
    vw: VirtualWindow,
    onBackButtonPressed?: () => any
}

const Header = ({vw, onBackButtonPressed}: HeaderProps) => {


    const backButtonHandler = useCallback((event) => {
        event.stopPropagation();
        if (onBackButtonPressed !== undefined) {
            onBackButtonPressed();
        }
    }, [onBackButtonPressed])

    const headerTitle = useCreation(() => {
        if (vw === undefined || vw.name === undefined) {
            return undefined;
        } else {
            return vw.name;
        }
    }, [vw])

    return (
        <div
            className="page-header dark-bg flk-clickable-item"
            onClick={backButtonHandler}
            style={{
                textAlign: "center"
            }}
        >
            <div
                onClick={backButtonHandler}
                className="flk-clickable-item"
                style={{
                    fontSize: "2.2vh",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",

                }}>
                {headerTitle}
            </div>

            <img alt="FromFilkers" style={{height: "1.4vh"}} src={FromFilkersText}/>

        </div>
    );
};

export default Header;
